/* eslint-disable @typescript-eslint/no-explicit-any */
import CryptoJS from 'crypto-js';

export const encrypt = (params: any) => {
  try {
    return {code: CryptoJS.AES.encrypt(params.text, params.key).toString()};
  }
  catch (error: any) {
    return {code: null};
  }
};